import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapActions } from 'vuex'

//components
import {ModalHeader, ModalContent, ModalFooter,ContentItem} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import ChangeApprovalPWView from './ChangeApprovalPWView.vue'

import * as types from '@gnb/store/types'

@Component({
    components:{
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        ChangeApprovalPWView
    },
    methods: {
        ...mapActions({
            loading: types.COMMON_LOADDING,
            load: types.SETTINGS_MYSETTING_LOAD,
            saveSetting: types.SETTINGS_MYSETTING_SAVE,
        })
    }
})
export default class ChangeApprovalPW extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    header:string = this.$t('결재_비밀번호_설정').toString();

    settingInfo: gnb.TA_MYSETTING = {} as gnb.TA_MYSETTING;
    WorkflowPWCheckType: string = 'workflow'; // 결재 비밀번호 유형 (workflow:기본 / ad: AD 비번)
    pwChecked: boolean = false; // 결재 비밀번호 확인완료 여부

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    
    loading!: (option: boolean) => void;
    load!: () => Promise<gnb.CM_MySetting>;
    saveSetting!: (payload: { data: gnb.TA_MYSETTING, isFirst: boolean }) => Promise<boolean>;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    /**
     * 전자결재 사용자 설정값을 저장합니다.
     * @returns 
     */
    save(){
        if(this.settingInfo.isApprovalPassword && !this.pwChecked){
            (window as any).alertAsync(this.$t('비밀번호를_확인해주세요').toString());
          return false;
        }
    
        this.saveSetting({ data: this.settingInfo, isFirst: false })
            .then((res: boolean) => {
                if (res) {
                    (window as any).alertAsync(this.$t('적용되었습니다').toString());
                    this.$emit('cancel');
                }
                else {
                    (window as any).alertAsync(this.$t('적용하는_도중에_문제가_발생했습니다').toString());
                }
            });
    
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created(){
        this.loading(true);
        this.load().then((res)=>{
            this.settingInfo = res.mySetting;
            if(this.settingInfo){
                this.loading(false);
            }
        });
        this.WorkflowPWCheckType = this.getAppConfig('WorkflowPWCheckType')?.toString().toLowerCase() || 'workflow';
    }
}